/* eslint-disable camelcase */
export default {
	query_condition: '查询条件',
	search_result: '查询结果',
	// placeholder
	please_input: '请输入',
	please_select: '请选择',
	please_upload: '请上传',
	please_search_and_select: '请搜索并选择',
	begin_date: '开始时间',
	end_date: '结束时间',
	end_datetime: '结束日期',
	to: '至',
	copy: '复制',
	edit: '编辑',
	new: '新增',
	delete: '删除',
	reapply: '重新申请',
	back_to_draft: '撤回至草稿',
	inquire: '查询',
	reset: '重置',
	export: '导出',
	import: '导入',
	back: '返回',
	save: '保存',
	validate_account: '打款验证',
	sign_contract: '签约',
	please_input_xxx: '请输入{desc}',
	please_select_xxx: '请选择{desc}',
	please_upload_xxx: '请上传{desc}',
	add: '添加',
	retry: '重试',
	choice: '选择',
	agree: '同意',
	reject: '驳回',
	transfer: '转交',
	yes: '是',
	no: '否',
	comfirmed: '已确认',
	uncomfirm: '未确认',
	confirm: '确定',
	cancel: '取消',
	tip: '提示',
	confirm_submit: '确认要提交吗?',
	confirm_delete: '确认要删除该吗?',
	submit: '提交',
	subfix_success: '成功',
	subfix_fail: '失败',
	// component里的翻译 开始

	please_input_keyword: '请输入关键字',
	please_input_keyword_to_search: '请输入关键字搜索',
	no_file: '无',
	none: '无',
	file: '文件',
	select_file: '选择文件',
	file_limit_warning: '文件：{fileName},大小超过{limitSize},当前文件大小{currentSize}',
	file_accept_warning: '文件：{fileName}, 类型不正确,可接受的文件类型为{acceptType}',
	upload_fail: '上传失败',
	preview_fail: '预览失败',
	at_most_upload: '最多上传{limit}个文件',
	delete_fail: '删除失败',
	delete_404_tip: '找不到该附件资源，请保存/提交后确认删除',
	tip_info: '提示信息',
	attachment: '附件',
	cert_expired_type: '证件有效期类型',
	regular: '定期',
	long_term: '长期',
	date: '日期',
	start_date_title: '开始日期',
	effect_date_title: '有效日期',
	start_date: '开始日期',
	effect_date: '生效日期',
	expired_date: '失效日期',
	more_condition: '更多条件',
	collapse: '收起',
	only_support_xxx: '仅支持{desc}类型的文件',
	on_processing: '当前还有文件在上传中，请稍等',
	// component里的翻译 结束
	effective: '有效',
	invalid: '作废',
	operate_successfully: '操作成功',
	operate_failure: '操作失败',
	my_profile: '个人资料卡',
	last_update_date: '最后更新时间',
	no_supplier_info: '未获取到供应商信息，请联系腾讯采购人员',
	invite_register: '邀请注册'
};
